import React, { Component } from "react";
import * as moment from "moment";
import * as $ from "jquery";

import ImportForm from "./ImportForm";
import DataService from "./DataService";
import { BRAND_REQUEST_GROUP_STATUSES } from "./enums";

export default class WelcomePage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.initializeDataTable("#open_batches_table");

    $('[data-toggle="tooltip"]').tooltip();
    $("#pills-archived-tab").one("shown.bs.tab", () => {
      this.initializeDataTable("#archived_batches_table");
    });
  }

  initializeDataTable(id) {
    const table = $(id).DataTable({
      serverSide: true,
      ajax: function(data, callback, settings) {
        DataService.getBrandRequestGroups({
          status:
            id === "#archived_batches_table"
              ? [BRAND_REQUEST_GROUP_STATUSES.FINISHED]
              : [
                  BRAND_REQUEST_GROUP_STATUSES.CSV_UPLOAD_COMPLETE,
                  BRAND_REQUEST_GROUP_STATUSES.USER_DONE
                ],
          name: data.search.value,
          fields:
            "id,name,dateEntered,status,brandRequest(note,brandRequestBrand(comparisonMethod))",
          limit: data.length,
          offset: data.start,
          sortBy: data.columns[data.order[0].column].data,
          sortDir: data.order[0].dir
        }).then(response =>
          callback({
            data: response.brandRequestGroups,
            recordsTotal: response.count,
            recordsFiltered: response.count
          })
        );
      },
      scrollCollapse: true,
      lengthChange: false,
      order: [[1, "desc"]],
      search: {
        regex: false,
        smart: true
      },
      pageLength: 50,
      deferRender: true,
      columns: [
        {
          data: "name",
          title: "Batch Title",
          render: {
            display: (_name, _type, brandRequestGroup) =>
              `<a href="activate/${brandRequestGroup.id}">${brandRequestGroup.name}</a>`
          }
        },
        {
          data: "dateEntered",
          title: "Date Created",
          render: {
            display: data => moment(data).format("DD/MM/YYYY"),
            filter: data => moment(data).format("DD/MM/YYYY")
          }
        },
        {
          data: "status",
          title: "Status",
          render: {
            display: (brandRequestGroupStatus, _type, brandRequestGroup) => {
              let html = `<div style="text-align: center;">`;
              if (
                brandRequestGroupStatus ===
                BRAND_REQUEST_GROUP_STATUSES.USER_DONE
              ) {
                html += `<i style="color: #007bff;" class="fa fa-check" aria-hidden="true" title="All requests processed"></i>`;
              }
              if (
                brandRequestGroup.brandRequest.some(br =>
                  br.brandRequestBrand.some(
                    brb => brb.comparisonMethod === "VisualSimilarity"
                  )
                )
              ) {
                html += `<i style="color: #D12555;" class="fa fa-exclamation-triangle" aria-hidden="true" title="Visually similar duplicate present"></i>`;
              }
              html += `</div>`;
              return html;
            }
          },
          orderable: false
        },
        {
          data: "brandRequest",
          title: "Notes",
          render: {
            display: brandRequests => {
              const noteCount = brandRequests.filter(br => br.note).length;
              if (noteCount) {
                return (
                  `<div style="text-align: center;">` +
                  `<i style="color: #ffc107;" class="fa fa-exclamation-triangle" aria-hidden="true"></i>${noteCount}` +
                  `</div>`
                );
              } else {
                return "";
              }
            },
            sort: brandRequests => {
              return brandRequests.filter(br => br.note).length;
            }
          },
          orderable: false
        },
        {
          title: "Actions",
          data: null,
          orderable: false,
          render: {
            display: data =>
              `<div style="text-align: center;"><i class="fa fa-times"  style='padding: 5px;color: red;cursor: pointer'/></div>`
          }
        }
      ]
    });

    const _this = this;

    $(id).on("click", "i.fa-times", async function() {
      const tableRow = table.row($(this).parents("tr"));
      if (await _this.deleteBrandRequestGroup(tableRow.data())) {
        tableRow.remove().draw();
      }
    });
  }

  /**
   *
   * @param {{name: string, dateEntered: string, id: string}} brandRequestGroup
   */
  async deleteBrandRequestGroup(brandRequestGroup) {
    if (
      // eslint-disable-next-line no-restricted-globals
      confirm(
        `Are you sure you want to permanently delete "${
          brandRequestGroup.name
        } - (${moment(brandRequestGroup.dateEntered).format("DD/MM/YYYY")})"?`
      )
    ) {
      await DataService.updateBrandRequestGroup(brandRequestGroup.id, {
        status: BRAND_REQUEST_GROUP_STATUSES.DELETED
      });
      return true;
    } else {
      return false;
    }
  }

  render() {
    const { company } = this.props;

    return (
      <div className="container">
        <div className="row">
          <div className="col">
            <ImportForm company={company} />
          </div>
          <div className="col">
            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  id="pills-open-batches-tab"
                  data-toggle="pill"
                  href="#pills-open-batches"
                  role="tab"
                  aria-controls="pills-open-batches"
                  aria-selected="true"
                >
                  Open Batches
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  id="pills-archived-tab"
                  data-toggle="pill"
                  href="#pills-archived-batches"
                  role="tab"
                  aria-controls="pills-archived-batches"
                  aria-selected="false"
                >
                  Archived Batches
                </a>
              </li>
            </ul>
            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="pills-open-batches"
                role="tabpanel"
                aria-labelledby="pills-open-batches-tab"
              >
                <table
                  id="open_batches_table"
                  className={`table table-bordered table-striped table-hover table-sm`}
                />
              </div>
              <div
                className="tab-pane fade"
                id="pills-archived-batches"
                role="tabpanel"
                aria-labelledby="pills-archived-tab"
              >
                <table
                  id="archived_batches_table"
                  className={`table table-bordered table-striped table-hover table-sm`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/WelcomePage.js